<template>
  <div class="page-title">
    {{ $t("user_page_title") }}
  </div>
  <div class="intro">{{ $t("user_subtitle") }}</div>
  <!--
  <el-row>
    <el-col :span="24">
      <el-row>
        <el-col class="container" :span="24">
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("calender_view_dht") }}</div>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("bg_color") }}</div>
                <el-color-picker
                  v-model="bgColor"
                  :disabled="true"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("text_color") }}</div>
                <el-color-picker
                  v-model="textColor"
                  :disabled="true"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("bg_color_service") }}</div>
                <el-color-picker
                  v-model="bgColorService"
                  :disabled="true"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("text_color_service") }}</div>
                <el-color-picker
                  v-model="textColorService"
                  :disabled="true"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("bg_color_today") }}</div>
                <el-color-picker
                  v-model="bgColorToday"
                  :disabled="true"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("text_color_service") }}</div>
                <el-color-picker
                  v-model="textColorToday"
                  :disabled="true"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("bg_color_announcements") }}</div>
                <el-color-picker
                  v-model="bgColorAnnouncement"
                  :disabled="true"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div>{{ $t("text_color_announcements") }}</div>
                <el-color-picker
                  v-model="textColorAnnouncement"
                  :disabled="true"
                ></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col class="container" :span="24">
          <el-row>
            <el-col :span="24">
              <div class="subtitle">{{ $t("frontend_view_calendar") }}</div>
            </el-col>
            <el-col :span="24">
              <el-image :src="require('@/img/gkt-logo.png')" :key="imageKey">
                <template #placeholder>
                  <div class="image-slot">
                    {{ $t("loading") }}
                  </div>
                </template>
              </el-image>
              <div class="calendar-preview">
                <div class="child">
                  <div
                    class="c-title"
                    :style="{
                      backgroundColor: bgColorToday,
                      color: textColorToday
                    }"
                  >
                    16. ({{ $t("today") }})
                  </div>
                  <div
                    class="c-content"
                    :style="{ backgroundColor: bgColorToday }"
                  >
                    <div
                      class="preview"
                      :style="{ backgroundColor: bgColorAnnouncement }"
                    >
                      <div
                        class="time"
                        :style="{ color: textColorAnnouncement }"
                      >
                        10:00 Uhr<br />bis 16:00 Uhr
                      </div>
                      <div
                        class="title"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Musterfirma
                      </div>
                      <div
                        class="subtitle"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Beispieltätigkeit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{
                      backgroundColor: bgColor,
                      color: textColor
                    }"
                  >
                    17.
                  </div>
                  <div class="c-content"></div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{
                      backgroundColor: bgColor,
                      color: textColor
                    }"
                  >
                    18.
                  </div>
                  <div class="c-content"></div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{
                      backgroundColor: bgColor,
                      color: textColor
                    }"
                  >
                    19.
                  </div>
                  <div class="c-content">
                    <div
                      class="preview"
                      :style="{ backgroundColor: bgColorService }"
                    >
                      <div class="time" :style="{ color: textColorService }">
                        10:45
                      </div>
                      <div class="title" :style="{ color: textColorService }">
                        Musterfirma
                      </div>
                      <div
                        class="subtitle"
                        :style="{ color: textColorService }"
                      >
                        Beispieltätigkeit
                      </div>
                    </div>
                    <div
                      class="preview"
                      :style="{ backgroundColor: bgColorAnnouncement }"
                    >
                      <div
                        class="time"
                        :style="{ color: textColorAnnouncement }"
                      >
                        10:00 Uhr<br />bis 16:00 Uhr
                      </div>
                      <div
                        class="title"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Musterfirma
                      </div>
                      <div
                        class="subtitle"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Beispieltätigkeit
                      </div>
                    </div>
                  </div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{ backgroundColor: bgColor, color: textColor }"
                  >
                    20.
                  </div>
                  <div class="c-content"></div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{ backgroundColor: bgColor, color: textColor }"
                  >
                    21.
                  </div>
                  <div class="c-content"></div>
                </div>
                <div class="child">
                  <div
                    class="c-title"
                    :style="{ backgroundColor: bgColor, color: textColor }"
                  >
                    22.
                  </div>
                  <div class="c-content">
                    <div
                      class="preview"
                      :style="{ backgroundColor: bgColorAnnouncement }"
                    >
                      <div
                        class="time"
                        :style="{ color: textColorAnnouncement }"
                      >
                        10:25 Uhr<br />bis 13:05 Uhr
                      </div>
                      <div
                        class="title"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Musterfirma 2
                      </div>
                      <div
                        class="subtitle"
                        :style="{ color: textColorAnnouncement }"
                      >
                        Beispieltätigkeit 2
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row> -->

  <el-row :gutter="32">
    <el-col :lg="12" :md="24">
      <div class="table-header">
        <HeadingTitle>
          <template #svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="58.964"
              height="42.804"
              viewBox="0 0 58.964 42.804"
            >
              <g
                id="icon"
                transform="translate(0 2.13)"
                fill="none"
                stroke-miterlimit="10"
              >
                <path
                  d="M20.593,3.511a12.1,12.1,0,0,0-13.817-2.3l8.06,8.035L9.265,14.8,1.2,6.769a12.038,12.038,0,0,0,15.117,16.5L33.24,40.132a1.853,1.853,0,0,0,2.619,0l4.271-4.258a1.84,1.84,0,0,0,0-2.611L23.286,16.452A12.021,12.021,0,0,0,20.593,3.511Z"
                  stroke="none"
                />
                <path
                  d="M 12.07417488098145 1.500003814697266 C 11.20808601379395 1.500003814697266 10.34191131591797 1.607166290283203 9.502870559692383 1.81524658203125 L 15.89516448974609 8.187904357910156 L 16.96072387695313 9.250194549560547 L 15.89516448974609 10.31248474121094 L 10.32380485534668 15.86673355102539 L 9.264774322509766 16.92251396179199 L 8.205743789672852 15.86673355102539 L 1.807868957519531 9.488513946533203 C 1.467662811279297 10.85878562927246 1.405803680419922 12.28575134277344 1.632152557373047 13.70220375061035 C 1.982425689697266 15.89413452148438 3.003604888916016 17.88619422912598 4.585292816162109 19.4630241394043 C 6.574073791503906 21.44569396972656 9.226503372192383 22.53759384155273 12.05396461486816 22.53759384155273 C 13.34055328369141 22.53759384155273 14.59907341003418 22.30999374389648 15.79457473754883 21.86112403869629 L 16.69768333435059 21.52203369140625 L 17.38086318969727 22.2031135559082 L 34.29922485351563 39.06950378417969 C 34.38530349731445 39.15532302856445 34.48282241821289 39.17333221435547 34.54947280883789 39.17333221435547 C 34.61612319946289 39.17333221435547 34.71364593505859 39.15532302856445 34.79971313476563 39.06951522827148 L 39.07110214233398 34.81124496459961 C 39.15560531616211 34.72700500488281 39.17334365844727 34.63263320922852 39.17334365844727 34.56829452514648 C 39.17334365844727 34.50396347045898 39.15560531616211 34.40958404541016 39.07051467895508 34.32475280761719 L 22.2264347076416 17.5139045715332 L 21.52929306030273 16.81813430786133 L 21.89063453674316 15.90188407897949 C 23.43479347229004 11.98641395568848 22.50983428955078 7.539592742919922 19.53418350219727 4.573093414306641 C 17.54646301269531 2.591472625732422 14.89726448059082 1.500095367431641 12.07439422607422 1.500003814697266 L 12.07417488098145 1.500003814697266 M 12.07464599609375 0 C 15.15889167785645 0.0001068115234375 18.24403190612793 1.168834686279297 20.59321403503418 3.51080322265625 C 24.10317420959473 7.009975433349609 24.99459457397461 12.1198844909668 23.28604316711426 16.45219421386719 L 40.13012313842773 33.26304244995117 C 40.85441207885742 33.98510360717773 40.85441207885742 35.15149307250977 40.13012313842773 35.87354278564453 L 35.85874557495117 40.13180541992188 C 35.49660873413086 40.49282455444336 35.02304458618164 40.67333221435547 34.54947662353516 40.67333221435547 C 34.07591247558594 40.67333221435547 33.60234451293945 40.49282455444336 33.24020385742188 40.13180541992188 L 16.32183456420898 23.26540374755859 C 14.95111274719238 23.78006362915039 13.50321578979492 24.03759384155273 12.05396270751953 24.03759384155273 C 8.967479705810547 24.03759384155273 5.876815795898438 22.86863899230957 3.526264190673828 20.52531433105469 C -0.2065467834472656 16.80396461486816 -0.9679641723632813 11.26823425292969 1.204864501953125 6.769294738769531 L 9.264774322509766 14.804443359375 L 14.83613395690918 9.250194549560547 L 6.776233673095703 1.215053558349609 C 8.442094802856445 0.4052696228027344 10.25807762145996 -6.103515625e-05 12.07464599609375 0 Z"
                  stroke="none"
                  fill="#fff"
                />
              </g>
              <rect
                id="Rechteck_126"
                data-name="Rechteck 126"
                width="35"
                height="20"
                transform="matrix(0.695, -0.719, 0.719, 0.695, 20.264, 25.177)"
                fill="#e18324"
              />
              <line
                id="Linie_59"
                data-name="Linie 59"
                x2="20.102"
                transform="translate(29.5 21.93)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="2"
              />
              <line
                id="Linie_60"
                data-name="Linie 60"
                x2="20.102"
                transform="translate(29.5 28.63)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="2"
              />
              <line
                id="Linie_61"
                data-name="Linie 61"
                x2="20.102"
                transform="translate(29.5 15.229)"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-width="2"
              />
            </svg>
          </template>
        </HeadingTitle>
        <div class="title">{{ $t("created_users") }}</div>
      </div>
      <div class="table-container">
        <vue-collapsible-panel-group accordion>
          <vue-collapsible-panel
            :name="user.name"
            v-for="user in userlist"
            :key="user.idmandate"
          >
            <template #title>
              {{ user.name }}
            </template>
            <template #actions>
              <Edit @click="edit(user)" />
              <el-popconfirm
                :confirmButtonText="$t('yes')"
                :cancelButtonText="$t('no')"
                :title="$t('delete_user_confirm')"
                @confirm="deleteUser(user.idmandate)"
              >
                <template #reference>
                  <Delete />
                </template>
              </el-popconfirm>
            </template>
            <template #content>
              <div class="user-data">
                <div class="row">
                  <div class="col">
                    <div class="loginname">{{ $t("loginname") }}</div>
                    <div class="container">{{ user.loginname }}</div>
                  </div>
                  <div class="col">
                    <div class="providermodule">{{ $t("providermodule") }}</div>
                    <div class="container">
                      {{ user.providermodul == 1 ? $t("yes") : $t("no") }}
                    </div>
                  </div>
                  <div class="col">
                    <div class="timetrackingmodule">
                      {{ $t("timetrackingmodule") }}
                    </div>
                    <div class="container">
                      {{ user.timetrackingmodul == 1 ? $t("yes") : $t("no") }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </vue-collapsible-panel>
        </vue-collapsible-panel-group>
      </div>
    </el-col>
    <el-col :lg="12" :md="24">
      <div class="table-header">
        <HeadingTitle>
          <template #svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="60.551"
              height="42.631"
              viewBox="0 0 60.551 42.631"
            >
              <g
                id="icon"
                transform="translate(0 1.958)"
                fill="none"
                stroke-miterlimit="10"
              >
                <path
                  d="M20.593,3.511a12.1,12.1,0,0,0-13.817-2.3l8.06,8.035L9.265,14.8,1.2,6.769a12.038,12.038,0,0,0,15.117,16.5L33.24,40.132a1.853,1.853,0,0,0,2.619,0l4.271-4.258a1.84,1.84,0,0,0,0-2.611L23.286,16.452A12.021,12.021,0,0,0,20.593,3.511Z"
                  stroke="none"
                />
                <path
                  d="M 12.07417488098145 1.500003814697266 C 11.20808601379395 1.500003814697266 10.34191131591797 1.607166290283203 9.502870559692383 1.81524658203125 L 15.89516448974609 8.187904357910156 L 16.96072387695313 9.250194549560547 L 15.89516448974609 10.31248474121094 L 10.32380485534668 15.86673355102539 L 9.264774322509766 16.92251396179199 L 8.205743789672852 15.86673355102539 L 1.807868957519531 9.488513946533203 C 1.467662811279297 10.85878562927246 1.405803680419922 12.28575134277344 1.632152557373047 13.70220375061035 C 1.982425689697266 15.89413452148438 3.003604888916016 17.88619422912598 4.585292816162109 19.4630241394043 C 6.574073791503906 21.44569396972656 9.226503372192383 22.53759384155273 12.05396461486816 22.53759384155273 C 13.34055328369141 22.53759384155273 14.59907341003418 22.30999374389648 15.79457473754883 21.86112403869629 L 16.69768333435059 21.52203369140625 L 17.38086318969727 22.2031135559082 L 34.29922485351563 39.06950378417969 C 34.38530349731445 39.15532302856445 34.48282241821289 39.17333221435547 34.54947280883789 39.17333221435547 C 34.61612319946289 39.17333221435547 34.71364593505859 39.15532302856445 34.79971313476563 39.06951522827148 L 39.07110214233398 34.81124496459961 C 39.15560531616211 34.72700500488281 39.17334365844727 34.63263320922852 39.17334365844727 34.56829452514648 C 39.17334365844727 34.50396347045898 39.15560531616211 34.40958404541016 39.07051467895508 34.32475280761719 L 22.2264347076416 17.5139045715332 L 21.52929306030273 16.81813430786133 L 21.89063453674316 15.90188407897949 C 23.43479347229004 11.98641395568848 22.50983428955078 7.539592742919922 19.53418350219727 4.573093414306641 C 17.54646301269531 2.591472625732422 14.89726448059082 1.500095367431641 12.07439422607422 1.500003814697266 L 12.07417488098145 1.500003814697266 M 12.07464599609375 0 C 15.15889167785645 0.0001068115234375 18.24403190612793 1.168834686279297 20.59321403503418 3.51080322265625 C 24.10317420959473 7.009975433349609 24.99459457397461 12.1198844909668 23.28604316711426 16.45219421386719 L 40.13012313842773 33.26304244995117 C 40.85441207885742 33.98510360717773 40.85441207885742 35.15149307250977 40.13012313842773 35.87354278564453 L 35.85874557495117 40.13180541992188 C 35.49660873413086 40.49282455444336 35.02304458618164 40.67333221435547 34.54947662353516 40.67333221435547 C 34.07591247558594 40.67333221435547 33.60234451293945 40.49282455444336 33.24020385742188 40.13180541992188 L 16.32183456420898 23.26540374755859 C 14.95111274719238 23.78006362915039 13.50321578979492 24.03759384155273 12.05396270751953 24.03759384155273 C 8.967479705810547 24.03759384155273 5.876815795898438 22.86863899230957 3.526264190673828 20.52531433105469 C -0.2065467834472656 16.80396461486816 -0.9679641723632813 11.26823425292969 1.204864501953125 6.769294738769531 L 9.264774322509766 14.804443359375 L 14.83613395690918 9.250194549560547 L 6.776233673095703 1.215053558349609 C 8.442094802856445 0.4052696228027344 10.25807762145996 -6.103515625e-05 12.07464599609375 0 Z"
                  stroke="none"
                  fill="#fff"
                />
              </g>
              <rect
                id="Rechteck_127"
                data-name="Rechteck 127"
                width="35"
                height="22"
                transform="matrix(0.719, -0.695, 0.695, 0.719, 20.092, 24.313)"
                fill="#e18324"
              />
              <g
                id="Gruppe_314"
                data-name="Gruppe 314"
                transform="translate(-1182 -308.765)"
              >
                <line
                  id="Linie_63"
                  data-name="Linie 63"
                  x2="18.776"
                  transform="translate(1210.5 331.81)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="2"
                />
                <line
                  id="Linie_64"
                  data-name="Linie 64"
                  x2="18.776"
                  transform="translate(1219.888 322.048) rotate(90)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="2"
                />
              </g>
            </svg>
          </template>
        </HeadingTitle>
        <div class="title" v-if="!editUser">
          {{ $t("add_new_user") }}
        </div>
        <div class="title" v-if="editUser">{{ $t("edit_user") }}</div>
      </div>
      <div class="table-container">
        <el-form
          label-width="0"
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("enter_data") }}</div>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="name">
                <el-input placeholder="Name" v-model="ruleForm.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="loginname">
                <el-input
                  :placeholder="$t('loginname')"
                  type="text"
                  v-model="ruleForm.loginname"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item prop="site_remote">
                <el-input
                  :placeholder="$t('editor_site_remote_idteam')"
                  v-model="ruleForm.site_remote"
                ></el-input>
              </el-form-item>
              <el-form-item prop="site_remote1">
                <el-input
                  :placeholder="$t('skonline_site_remote_idteam')"
                  v-model="ruleForm.site_remote1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="password">
                <el-input
                  :placeholder="$t('password')"
                  show-password
                  v-model="ruleForm.password"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item>
                <el-checkbox
                  v-model="timetrackingmodul"
                  :label="$t('timetrackingmodule')"
                  border
                ></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-checkbox
                  v-model="providermodul"
                  :label="$t('providermodule')"
                  border
                ></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-checkbox
                  v-model="noticesfield"
                  :label="$t('notices_field_avaible')"
                  border
                ></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editUser">
              <el-form-item>
                <el-checkbox
                  v-model="deleteentries"
                  :label="$t('can_deleteentries')"
                  border
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item v-if="!editUser">
            <el-button round @click="submitForm('ruleForm')">{{
              $t("add_user")
            }}</el-button>
          </el-form-item>

          <el-form-item v-if="editUser">
            <el-button type="danger" round @click="cancelEdit()">{{
              $t("cancel")
            }}</el-button>

            <el-button round @click="submitChangeForm('ruleForm')">{{
              $t("save")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-header" v-if="editUser">
        <HeadingTitle>
          <template #svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="47"
              viewBox="0 0 44 47"
            >
              <g
                id="Gruppe_317"
                data-name="Gruppe 317"
                transform="translate(-182 -241)"
              >
                <g
                  id="Rechteck_125"
                  data-name="Rechteck 125"
                  transform="translate(190 241)"
                  fill="none"
                  stroke="#fff"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                >
                  <rect width="36" height="40" rx="4" stroke="none" />
                  <rect
                    x="0.75"
                    y="0.75"
                    width="34.5"
                    height="38.5"
                    rx="3.25"
                    fill="none"
                  />
                </g>
              </g>
              <g
                id="Gruppe_316"
                data-name="Gruppe 316"
                transform="translate(-190 -234)"
              >
                <g
                  id="Rechteck_125-2"
                  data-name="Rechteck 125"
                  transform="translate(190 241)"
                  fill="#e18324"
                  stroke="#fff"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                >
                  <rect width="36" height="40" rx="4" stroke="none" />
                  <rect
                    x="0.75"
                    y="0.75"
                    width="34.5"
                    height="38.5"
                    rx="3.25"
                    fill="none"
                  />
                </g>
                <line
                  id="Linie_55"
                  data-name="Linie 55"
                  x2="18.997"
                  transform="translate(198.009 250.871)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="1.5"
                />
                <line
                  id="Linie_56"
                  data-name="Linie 56"
                  x2="18.997"
                  transform="translate(198.009 257.576)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="1.5"
                />
                <line
                  id="Linie_57"
                  data-name="Linie 57"
                  x2="6.705"
                  transform="translate(210.301 270.986)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </template>
        </HeadingTitle>
        <div class="title">
          {{ $t("client_urls_protection") }}
        </div>
      </div>
      <div class="table-container" v-if="editUser">
        <!-- enter passowrd protection -->
        <el-form
          label-width="0"
          :model="ruleFormProtection"
          status-icon
          :rules="rulesProtection"
          ref="ruleFormProtection"
        >
          <el-row :gutter="24">
            <el-col :span="24">
              <el-checkbox
                class="gkt-checkbox"
                v-model="ruleFormProtection.enable"
                :label="$t('client_urls_protection_enabled')"
                border
              ></el-checkbox>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("enter_data") }}</div>
            </el-col>

            <el-col :span="12" v-if="ruleFormProtection.enable">
              <el-form-item prop="salt">
                <el-input
                  :placeholder="$t('salt')"
                  type="text"
                  v-model="ruleFormProtection.salt"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="ruleFormProtection.enable">
              <el-form-item prop="oldsalt">
                <el-input
                  :placeholder="$t('oldsalt')"
                  type="text"
                  v-model="ruleFormProtection.oldsalt"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item prop="olddate">
                <el-date-picker
                  v-if="ruleFormProtection.enable"
                  class="gkt-date-picker"
                  type="date"
                  size="mini"
                  v-model="ruleFormProtection.olddate"
                  @change="setOldValidDate()"
                  :placeholder="$t('end')"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="editUser">
            <el-button type="danger" round @click="cancelEdit()">{{
              $t("cancel")
            }}</el-button>

            <el-button
              round
              @click="submitChangeFormProtection('ruleFormProtection')"
              >{{ $t("save") }}</el-button
            >
          </el-form-item>
        </el-form>
        <el-button round @click="getjavascript('ruleFormProtection')">{{
          $t("getconfiguration_project")
        }}</el-button>
        <el-button round @click="copyclipboard('ruleFormProtection')">{{
          $t("getconfiguration_project_copy")
        }}</el-button>
      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.client-urls-expanded {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  a {
    color: $gkt-orange;
    font-weight: bold;
    margin-bottom: 4px;
    text-decoration: none;
  }

  input {
    margin: 0;
    padding: 4px 12px;
    margin-bottom: 12px;
  }
}

.user-data {
  padding: 12px 0 12px 0;
  font-size: 13px;

  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    .loginname,
    .providermodule,
    .timetrackingmodule {
      font-size: 15px;
      color: $gkt-orange;
    }

    .container {
      min-height: 44px;
      padding-right: 24px;
    }

    .col {
      flex: 1;
    }
  }
}
.gktcolor {
  color: $gkt-orange;
}

.el-collapse {
  margin-bottom: 24px;

  ::v-deep(.el-collapse-item__wrap) {
    background-color: transparent !important;
    padding-top: 12px;
  }

  ::v-deep(.el-collapse-item__header) {
    background-color: #e6e6e6 !important;
    padding: 0 12px;
  }
}

.table-header {
  background-color: $gkt-orange-rgba;
  padding: 24px;
  border-top-left-radius: 21px;
  border-top-right-radius: 21px;
  display: flex;
  align-items: center;
  padding-bottom: 72px;

  .title {
    font-size: 21px;
    font-weight: 500;
    color: $gkt-white;
  }
}

.actions {
  position: relative;
  display: flex;
  align-self: center;
  justify-content: flex-end;
  flex: 1;
  z-index: 666;

  .small-rounded-btn.toggle-up {
    display: none;
  }
}

.subtitle {
  font-size: 15px;
  color: $gkt-orange-rgba;
  margin-bottom: 12px;
}

.table-container {
  padding: 24px 48px;
  background-color: $gkt-light-grey;
  border-radius: 21px;
  max-height: calc(100vh - 347px);
  overflow: auto;
  position: relative;
  top: -48px;

  .assigned-services {
    font-size: 15px;
    font-weight: 500;
    color: $gkt-orange;
  }

  .no-services {
    margin-top: 12px;
    color: darken($gkt-light-grey, 10);
  }

  .services {
    margin: 0;
    padding: 0;
    margin-top: 12px;
    list-style: none;

    li {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      justify-items: center;
      align-content: center;
      align-items: center;
    }
  }
}
.subtitle {
  font-size: 21px;
  font-weight: 500;
  color: $gkt-orange-rgba;
  margin-bottom: 12px;
}

::v-deep(.el-color-picker) {
  .el-color-picker__mask,
  .el-color-picker__icon {
    display: none !important;
  }
}

.container {
  padding: 24px;

  &:last-child {
    padding-top: 0;
    margin-bottom: 12px;
  }
}

.calendar-preview {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid $gkt-orange;
  border-radius: 24px;
  background-color: #ffffff;
  overflow: hidden;

  .child {
    flex: 0 0 14.28%;
    height: 275px;

    .c-title {
      font-weight: bold;
      padding: 6px 12px;
      background-color: $gkt-light-grey;
      border-bottom-width: 4px;
      border-bottom-style: solid;
      border-bottom-color: darken($gkt-light-grey, 5);
      border-right: 4px solid darken($gkt-light-grey, 5);
    }

    .c-content {
      padding: 6px;
      height: 100%;
      min-height: 126px;
      border-right: 4px solid darken($gkt-light-grey, 5);

      .preview {
        border-radius: 24px;
        padding: 12px;
        position: relative;
        height: 102px;
        min-height: 100px;
        margin-bottom: 12px;

        .time,
        .title,
        .subtitle {
          position: absolute;
        }

        .time {
          line-height: 14px;
          bottom: 12px;
          right: 12px;
        }

        .title {
          font-size: 18px;
          left: 12px;
          top: 12px;
          font-weight: bold;
        }

        .subtitle {
          top: 36px;
          left: 12px;
          font-size: 14px;
        }
      }
    }

    &:first-child {
      border-top-left-radius: 24px;

      .c-title {
        border-top-left-radius: 24px;
        border-right: 4px solid darken($gkt-light-grey, 5);
      }

      .c-content {
        border-right: 4px solid darken($gkt-light-grey, 5);
      }
    }

    &:last-child {
      border-top-right-radius: 24px;
      flex: 0 0 14.32%;

      .c-title {
        border-top-right-radius: 24px;
        border-right: 0;
      }

      .c-content {
        border-right: 0;
      }
    }
  }
}
</style>

<script>
import { provide } from "vue";
import store from "@/store";
import { Delete, Edit, HeadingTitle } from "@/components/buttons";
import VueCollapsiblePanelGroup from "@/components/collapsible/VueCollapsiblePanelGroup.vue";
import VueCollapsiblePanel from "@/components/collapsible/VueCollapsiblePanel.vue";

export default {
  name: "users",
  setup() {
    provide("store", store);
  },
  components: {
    Delete,
    HeadingTitle,
    Edit,
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel
  },
  data() {
    var validateSalt = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_password")));
      } else {
        callback();
      }
    };

    var validateOldSalt = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_password")));
      } else {
        callback();
      }
    };

    var validateOldDate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("select_date")));
      } else {
        callback();
      }
    };

    var validatePass = (rule, value, callback) => {
      if (value === "" && !this.editUser) {
        callback(new Error(this.$t("enter_password")));
      } else {
        if (this.ruleForm.password !== "") {
          this.$refs.ruleForm.validateField("password");
        }
        callback();
      }
    };

    var validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_name")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("name");
        }
        callback();
      }
    };

    var validateLoginName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_loginname")));
      } else {
        if (this.ruleForm.loginname !== "") {
          this.$refs.ruleForm.validateField("loginname");
        }
        callback();
      }
    };

    var validateSiteRemote = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_site_remote")));
      } else {
        if (this.ruleForm.site_remote !== "") {
          this.$refs.ruleForm.validateField("site_remote");
        }
        callback();
      }
    };
    var validateSiteRemote1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_site_remote")));
      } else {
        if (this.ruleForm.site_remote1 !== "") {
          this.$refs.ruleForm.validateField("site_remote1");
        }
        callback();
      }
    };

    return {
      imageKey: 0,
      bgColor: "#FFFFFF",
      textColor: "#000000",
      bgColorService: "#FFFFFF",
      textColorService: "#000000",
      bgColorToday: "#D0D0D0",
      textColorToday: "#000000",
      bgColorAnnouncement: "#D0D0D0",
      textColorAnnouncement: "#7F1010",
      ruleForm: {
        name: "",
        loginname: "",
        site_remote: -1,
        site_remote1: -1,
        password: ""
      },
      ruleFormProtection: {
        enable: false,
        salt: "",
        oldsalt: "",
        olddate: ""
      },
      rules: {
        name: [{ validator: validateName, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        site_remote: [{ validator: validateSiteRemote, trigger: "blur" }],
        site_remote1: [{ validator: validateSiteRemote1, trigger: "blur" }],
        loginname: [{ validator: validateLoginName, trigger: "blur" }]
      },
      rulesProtection: {
        salt: [{ validator: validateSalt, trigger: "blur" }],
        oldsalt: [{ validator: validateOldSalt, trigger: "blur" }],
        olddate: [{ validator: validateOldDate, trigger: "blur" }]
      },
      activeName: "0",
      userlist: [],
      clientURL: [],
      providermodul: true,
      timetrackingmodul: true,
      noticesfield: false,
      deleteentries: false,
      editUser: false
    };
  },
  methods: {
    edit(user) {
      //this.getClientUrls(user.idmandate);
      this.getUrlProtection(user.idmandate);
      this.editUser = user;
      this.ruleForm.password = "";
      this.ruleForm.name = user.name;
      this.ruleForm.loginname = user.loginname;
      this.ruleForm.site_remote = user.idteam_siteremote;
      this.ruleForm.site_remote1 = user.idteam_siteremote1;
      this.providermodul = user.providermodul == 1 ? true : false;
      this.noticesfield = user.noticesfield == 1 ? true : false;
      this.deleteentries = user.deleteentries == 1 ? true : false;
      this.timetrackingmodul = user.timetrackingmodul == 1 ? true : false;
      this.urltoken = user.urltoken;
    },
    getURL(id, extra = "", token = "") {
      const add = extra != "" ? "view=" + extra : "ro=1";
      const path = process.env.VUE_APP_BASE_PATH;

      return (
        path +
        "client/index.html?idmandate=" +
        this.editUser.idmandate +
        "&iddevice=" +
        id +
        "&" +
        add +
        "#" +
        token
      );
    },
    getProjectURL(extra = "") {
      const path = process.env.VUE_APP_BASE_PATH;
      return path + "client/index.html#" + extra;
    },
    cancelEdit() {
      this.editUser = false;
      this.clearData();
    },

    clearData() {
      this.ruleForm.password = "";
      this.ruleForm.name = "";
      this.ruleForm.loginname = "";
      this.ruleForm.site_remote = -1;
      this.providermodul = true;
      this.timetrackingmodul = true;
      this.noticesfield = false;
      this.deleteentries = false;
      this.ruleFormProtection.enable = false;
      this.ruleFormProtection.salt = "";
      this.ruleFormProtection.oldsalt = "";
      this.ruleFormProtection.olddate = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const response = await store.methods.apiRequest("adduser", {
            name: this.ruleForm.name,
            loginname: this.ruleForm.loginname,
            password: this.ruleForm.password,
            idteam_siteremote: this.ruleForm.site_remote,
            idteam_siteremote1: this.ruleForm.site_remote1,
            providermodul: this.providermodul,
            timetrackingmodul: this.timetrackingmodul,
            noticesfield: this.noticesfield
          });

          const res = response.data;

          if (res.status == "success") {
            this.$message({
              showClose: true,
              message: this.$t("user_created"),
              type: "success",
              offset: 350
            });
            this.clearData();
            this.getUsers();
          } else {
            this.$message({
              showClose: true,
              message: this.$t("loginname_already_exists"),
              type: "error",
              offset: 350
            });
          }
        } else {
          return false;
        }
      });
    },
    submitChangeForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let params = {
            idmandate: this.editUser.idmandate,
            name: this.ruleForm.name,
            loginname: this.ruleForm.loginname,
            idteam_siteremote: this.ruleForm.site_remote,
            idteam_siteremote1: this.ruleForm.site_remote1,
            providermodul: this.providermodul,
            timetrackingmodul: this.timetrackingmodul,
            noticesfield: this.noticesfield,
            deleteentries: this.deleteentries
          };

          if (this.ruleForm.password != "")
            params.password = this.ruleForm.password;

          const response = await store.methods.apiRequest("changeuser", params);

          const res = response.data;

          if (res.status == "success") {
            this.$message({
              showClose: true,
              message: this.$t("user_changed"),
              type: "success",
              offset: 350
            });
            this.cancelEdit();
            this.getUsers();
          } else {
            this.$message({
              showClose: true,
              message: res.errordetails,
              type: "error",
              offset: 350
            });
          }
        } else {
          return false;
        }
      });
    },
    copyclipboard() {
      let params = {
        mandate: this.ruleForm.name,
        salt: this.ruleFormProtection.salt,
        CLEANING_BASE_URL: "https://cleaning.digitale-haustafel.de/client"
      };
      const config = "PROJECTSETTINGS=" + JSON.stringify(params);
      navigator.clipboard.writeText(config);
    },
    getjavascript() {
      let params = {
        mandate: this.ruleForm.name,
        salt: this.ruleFormProtection.salt,
        CLEANING_BASE_URL: "https://cleaning.digitale-haustafel.de/client"
      };
      const config = "PROJECTSETTINGS=" + JSON.stringify(params);
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/json;charset=utf-8,%EF%BB%BF" + encodeURI(config)
      );
      link.setAttribute("download", "cleaning_portal_settings.js");
      link.click();
    },
    submitChangeFormProtection(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let tdate = this.ruleFormProtection.olddate;
          if (typeof tdate.toISOString != "undefined") {
            tdate = new Date(
              tdate.getTime() - tdate.getTimezoneOffset() * 60 * 1000
            );
            tdate = tdate.toISOString() + "";
            if (tdate.includes("T")) {
              tdate = tdate.split("T")[0];
            }
          }
          let params = {
            idmandate: this.editUser.idmandate,
            enable: this.ruleFormProtection.enable,
            salt: this.ruleFormProtection.salt,
            oldsalt: this.ruleFormProtection.oldsalt,
            enddate: tdate
          };

          const response = await store.methods.apiRequest(
            "admin_seturlprotection",
            params
          );
          const res = response.data;

          if (res.status == "success") {
            this.$message({
              showClose: true,
              message: this.$t("client_urls_protection_changed"),
              type: "success",
              offset: 350
            });
          } else {
            this.$message({
              showClose: true,
              message: res.errordetails,
              type: "error",
              offset: 350
            });
          }
        } else {
          return false;
        }
      });
    },
    async deleteUser(id) {
      const response = await store.methods.apiRequest("removeuser", {
        idmandate: id
      });

      const res = response.data;

      if (res.status == "success") {
        this.$message({
          showClose: true,
          message: this.$t("user_deleted"),
          type: "success",
          offset: 350
        });

        this.getUsers();
      } else {
        this.$message({
          showClose: true,
          message: res.errordetails,
          type: "error",
          offset: 350
        });
      }
    },
    async getUsers() {
      const response = await store.methods.apiRequest("getusers");
      const res = response.data;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results && res.results.userlist) {
        this.userlist = res.results.userlist.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      }
    },
    async getClientUrls(id) {
      const response = await store.methods.apiRequest("admin_getlocations", {
        idmandate: id
      });

      const res = response.data;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results.locations[0]) {
        let clientURL = res.results.locations[0].reduce((r, a) => {
          if (a.grp != "") r[a.grp] = [...(r[a.grp] || []), a];
          return r;
        }, {});

        this.clientURL = clientURL;
      } else {
        this.clientURL = [];
      }
    },
    async getUrlProtection(id) {
      const response = await store.methods.apiRequest(
        "admin_geturlprotection",
        {
          idmandate: id
        }
      );
      const res = response.data;
      if (res.status) {
        if (res.status == "success") {
          this.ruleFormProtection.enable = res.results.enable;
          this.ruleFormProtection.salt = res.results.salt;
          this.ruleFormProtection.oldsalt = res.results.old_salt;
          if (res.results.old_date_valid != "") {
            this.ruleFormProtection.olddate = res.results.old_date_valid;
          } else {
            this.ruleFormProtection.olddate = new Date()
              .toISOString()
              .split("T")[0];
          }
        }
      }
    }
  },
  async mounted() {
    this.getUsers();
  }
};
</script>
